import React, { useEffect, useRef } from 'react';
import { experience } from './data';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './experience.scss';

gsap.registerPlugin(ScrollTrigger);

const Experience = () => {
    const experienceRef = useRef(null);
    const titleRef = useRef(null);
    const timelineRef = useRef([]);

    useEffect(() => {
        const ctx = gsap.context(() => {
            // Title animation
            gsap.from(titleRef.current, {
                scrollTrigger: {
                    trigger: titleRef.current,
                    start: 'top 80%',
                },
                y: 50,
                opacity: 0,
                duration: 1,
                ease: 'power3.out'
            });

            // Timeline items animation
            timelineRef.current.forEach((item, index) => {
                gsap.from(item, {
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 85%',
                    },
                    x: index % 2 === 0 ? -100 : 100,
                    opacity: 0,
                    duration: 0.8,
                    ease: 'power3.out'
                });
            });

        }, experienceRef);

        return () => ctx.revert();
    }, []);

    return (
        <section className="experience" ref={experienceRef}>
            <div className="experience-container">
                <h2 className="section-title" ref={titleRef}>
                    Work Experience
                </h2>
                <p className="section-subtitle">
                    My professional journey and career highlights
                </p>

                <div className="timeline">
                    <div className="timeline-line"></div>
                    {experience.map((exp, index) => (
                        <div 
                            key={exp.id}
                            className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                            ref={el => timelineRef.current[index] = el}
                        >
                            <div className="timeline-dot"></div>
                            <div className="timeline-content">
                                <div className="company-header">
                                    <div className="company-logo">
                                        <img 
                                            src={require(`../../assets/experience/${exp.companyLogo}`)} 
                                            alt={exp.companyName}
                                        />
                                    </div>
                                    <div className="company-info">
                                        <h3 className="company-name">{exp.companyName}</h3>
                                        <h4 className="job-title">{exp.jobTitle}</h4>
                                        <p className="duration">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {exp.to ? `${exp.from} - ${exp.to}` : exp.from}
                                        </p>
                                    </div>
                                </div>
                                {exp.keyProjects && exp.keyProjects.length > 0 && (
                                    <div className="key-projects">
                                        <h5 className="key-projects-title">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            Key Projects
                                        </h5>
                                        <div className="projects-grid">
                                            {exp.keyProjects.map((project) => (
                                                <div key={project.id} className="project-card-mini">
                                                    <div className="project-mini-header">
                                                        <h6 className="project-mini-name">{project.name}</h6>
                                                    </div>
                                                    <p className="project-mini-desc">{project.description}</p>
                                                    <div className="project-mini-tech">
                                                        {project.tech.map((tech, idx) => (
                                                            <span key={idx} className="tech-tag">{tech}</span>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <ul className="responsibilities">
                                    {exp.description.map((desc) => (
                                        <li key={desc.id}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            {desc.desc}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
